import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ServiciosComplementariosSection() {
  const services = ['Annual Report', 'Landing page profesional', 'Dominio y correo corporativo', 'Organización inicial de presencia digital'];
  return <section className="py-16 md:py-20 bg-gray-50 border-t border-gray-100" data-id="element-512">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-513">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-514">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-inkova-primary mb-8" data-id="element-515">
            También podemos ayudarte con lo que viene después
          </h2>

          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 mb-8" data-id="element-516">
            <ul className="space-y-4 text-left max-w-sm mx-auto" data-id="element-517">
              {services.map((service, i) => <li key={i} className="flex items-center text-gray-700 text-sm md:text-base" data-id="element-518">
                  <CheckCircle2 className="w-5 h-5 text-inkova-accent mr-3 flex-shrink-0" data-id="element-519" />
                  {service}
                </li>)}
            </ul>
          </div>

          <a href="https://wa.me/17863037695?text=Hola%2C%20quiero%20consultar%20sobre%20sus%20opciones%20complementarias" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-3.5 rounded-full border-2 border-inkova-primary text-inkova-primary font-bold text-sm md:text-base hover:bg-inkova-primary hover:text-white transition-colors duration-300" data-id="element-520">
            Consultar opciones complementarias
          </a>
        </motion.div>
      </div>
    </section>;
}